<!-- @format -->

<template>
	<pc-form-item
		:label="pcProps.isHiddenLabel ? '' : pcProps.label"
		:rules="itemRules"
		:help-tips="pcProps.helpTips"
		:label-position="formAttribute.labelPosition"
		:value-position="pcProps.position"
		:label-width="labelWidth"
	>
		<widget-form-item v-model="value" :type="type" :pc-props="pcProps" :item="item" :disabled="disabled" />
	</pc-form-item>
</template>

<script setup lang="ts">
	import WidgetFormItem from './widget-form-item.vue';
	import type { WidgetConfigType, FieldsType } from '../../types';
	import type { FormItemRule } from 'element-plus';
	import { PcFormItem } from '@/components';

	interface Props {
		type: string;
		pcProps: Partial<WidgetConfigType>;
		modelValue: any;
		item?: FieldsType;
		hidden?: boolean;
		disabled?: boolean;
		deleteFiled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue']);

	const formAttribute: Record<string, any> = inject('formAttribute', {});

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const labelWidth = computed(() => {
		return props.pcProps.labelWidth || formAttribute.labelWidth;
	});

	const getItemRules = (pcProps: Partial<WidgetConfigType>, hidden?: boolean): FormItemRule[] => {
		const rule: FormItemRule[] = [];
		if (hidden || pcProps.hidden || props.deleteFiled) {
			return [];
		}

		if (pcProps.isRequired === '2') {
			rule.push({
				required: true,
				message: pcProps.requiredMsg || `${pcProps.label}不能为空`,
				trigger: 'change',
			});
		}

		if (pcProps.validation) {
			const validateField = (_: any, value: any, callback: any) => {
				const reg = new RegExp(pcProps.validation!);
				const isDiff = reg.test(value ? value.toString() : '');

				if (value && !isDiff) {
					callback(new Error(pcProps.validErrorMsg || '字段校验失败'));
				} else {
					callback();
				}
			};
			rule.push({
				validator: validateField,
				trigger: 'blur',
			});
		}

		if (pcProps.maxlength) {
			const validateField = (_: any, value: any, callback: any) => {
				if (value && value.length > pcProps.maxlength!) {
					callback(`字段最大长度为${pcProps.maxlength}`);
				}
				callback();
			};
			rule.push({
				validator: validateField,
				trigger: 'blur',
			});
		}
		return rule;
	};

	const itemRules = computed(() => {
		return props.pcProps ? getItemRules(props.pcProps, props.hidden) : [];
	});
</script>

<style scoped lang="scss"></style>
